import React from 'react';

export default function Terms() {
  return (
    <div style={{ padding: '20px' }}>
      <h1>Terms of Service</h1>
      <p>
        By using this website, you agree to comply with all applicable laws and regulations. You acknowledge that this
        service is provided "as is" without any warranties.
      </p>
      <h2>Usage Policy</h2>
      <p>
        This website does not endorse or encourage the unauthorized downloading or distribution of copyrighted content.
        Users are solely responsible for ensuring that they have the legal right to access and download media.
      </p>
      <h2>Third-Party Services</h2>
      <p>
        Our platform may rely on third-party APIs for retrieving media content. We are not responsible for the availability,
        functionality, or content provided by these external services.
      </p>
      <h2>Disclaimer</h2>
      <p>
        We do not host any media files on our servers and are not liable for any misuse of the service. Users assume full
        responsibility for their actions while using this website.
      </p>
    </div>
  );
}